module.exports = __webpack_public_path__ + "static/media/chapters-list-image.df659733.png";